import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { SearchOff as SearchOffIcon } from '@mui/icons-material';

const EmptyData = ({ message, onRetry }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: '200px',
        textAlign: 'center',
        backgroundColor: 'background.paper',
        borderRadius: 2,
        padding: 2,
      }}
    >
      <SearchOffIcon sx={{ fontSize: 50, color: 'gray' }} />
      <Typography variant="h6" color="text.secondary" sx={{ marginTop: 2 }}>
        {message || 'No data available at the moment.'}
      </Typography>
      {onRetry && (
        <Button
          variant="contained"
          color="primary"
          sx={{ marginTop: 2 }}
          onClick={onRetry}
        >
          Retry
        </Button>
      )}
    </Box>
  );
};

export default EmptyData;
